import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserRepositoriesFactory from '../Repositories/factory.js'
import {GetMessagingChannelContextUserRequest} from '../Requests/GetMessagingChannelContextUserRequest.js'

export class GetMessagingChannelContextUserUseCase extends UseCase {
  #repository
  #config

  constructor({config, repository}) {
    super()
    this.#config = config
    this.#repository = repository
  }

  static create({config}) {
    return new GetMessagingChannelContextUserUseCase({
      config,
      repository: UserRepositoriesFactory.httpUserRepository({config})
    })
  }

  @tracer({metric: 'GetMessagingChannelContextUserUseCase#execute'})
  @AsyncInlineError()
  async execute({channelId}) {
    const [error, response] = await this.#repository.getMessagingChannelContext({
      getMessagingChannelContextUserRequest: GetMessagingChannelContextUserRequest.create({channelId})
    })

    if (error) return Promise.reject(error)

    return response.toJSON()
  }
}

export const factory = GetMessagingChannelContextUserUseCase.create
